var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.692 14v2.029c0 .523-.561.952-1.247.952L10.197 17c-.685 0-1.246-.429-1.246-.952v-2.029M7.716 11.082 11.38 7.54a1.377 1.377 0 0 1 1.907 0l3.663 3.542",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.523 19.263a9.666 9.666 0 0 0 6.804 2.793 9.666 9.666 0 0 0 6.804-2.793 9.424 9.424 0 0 0 2.816-6.735 9.475 9.475 0 0 0-2.816-6.734A9.666 9.666 0 0 0 12.327 3a9.666 9.666 0 0 0-6.804 2.794 9.424 9.424 0 0 0-2.816 6.734",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1 10.944 1.707 2.083 1.894-1.883",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgReset as Component };
export default __webpack_public_path__ + "64c6218a4743edbd057e39070bcc1851.svg";